exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labor-rate-link{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px;font-size:1.4rem;padding:15px}.labor-rate-link header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/claim/shared/components/labor-rate-link-panel.scss
// module id = 5059
// module chunks = 0